var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _g, _g2, _g3, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBirthdaySpecial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 200,
    viewBox: "0 0 800 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "#FFEBEE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 30,
    r: 3,
    fill: "#F06292"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 50,
    r: 2,
    fill: "#BA68C8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 20,
    r: 4,
    fill: "#64B5F6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 40,
    r: 3,
    fill: "#4FC3F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 60,
    r: 2,
    fill: "#81C784"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 30,
    r: 3,
    fill: "#FFD54F"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 50,
    r: 2,
    fill: "#FF8A65"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 20,
    r: 4,
    fill: "#F06292"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 40,
    r: 3,
    fill: "#BA68C8"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 60,
    r: 2,
    fill: "#64B5F6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 30,
    r: 3,
    fill: "#4FC3F7"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 50,
    r: 2,
    fill: "#81C784"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 20,
    r: 4,
    fill: "#FFD54F"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 40,
    r: 3,
    fill: "#FF8A65"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 60,
    r: 2,
    fill: "#F06292"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 160,
    r: 3,
    fill: "#FFD54F"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 180,
    r: 2,
    fill: "#FF8A65"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 4,
    fill: "#F06292"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 170,
    r: 3,
    fill: "#BA68C8"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 140,
    r: 2,
    fill: "#64B5F6"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 160,
    r: 3,
    fill: "#4FC3F7"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 180,
    r: 2,
    fill: "#81C784"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 150,
    r: 4,
    fill: "#FFD54F"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 170,
    r: 3,
    fill: "#FF8A65"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 140,
    r: 2,
    fill: "#F06292"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 160,
    r: 3,
    fill: "#BA68C8"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 180,
    r: 2,
    fill: "#64B5F6"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 150,
    r: 4,
    fill: "#4FC3F7"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 170,
    r: 3,
    fill: "#81C784"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 140,
    r: 2,
    fill: "#FFD54F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -10,
    width: 60,
    height: 30,
    rx: 5,
    fill: "#FFCDD2",
    stroke: "#E57373",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -20,
    width: 70,
    height: 10,
    rx: 2,
    fill: "#F8BBD0",
    stroke: "#F06292",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -30,
    width: 3,
    height: 10,
    fill: "#BA68C8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -35,
    width: 3,
    height: 15,
    fill: "#64B5F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -40,
    width: 3,
    height: 20,
    fill: "#FFD54F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: -35,
    width: 3,
    height: 15,
    fill: "#81C784"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: -30,
    width: 3,
    height: 10,
    fill: "#F06292"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -18.5,
    cy: -32,
    rx: 2,
    ry: 3,
    fill: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -8.5,
    cy: -37,
    rx: 2,
    ry: 3,
    fill: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.5,
    cy: -42,
    rx: 2,
    ry: 3,
    fill: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5,
    cy: -37,
    rx: 2,
    ry: 3,
    fill: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.5,
    cy: -32,
    rx: 2,
    ry: 3,
    fill: "#FFEB3B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(700, 90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L-15 -40",
    stroke: "#616161",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L0 -50",
    stroke: "#616161",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L15 -45",
    stroke: "#616161",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -15,
    cy: -50,
    rx: 10,
    ry: 15,
    fill: "#E57373"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -60,
    rx: 10,
    ry: 15,
    fill: "#64B5F6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: -55,
    rx: 10,
    ry: 15,
    fill: "#81C784"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -20,
    width: 40,
    height: 40,
    fill: "#F48FB1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -5,
    width: 50,
    height: 10,
    fill: "#EC407A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -25,
    width: 10,
    height: 50,
    fill: "#EC407A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -5,
    cy: -5,
    r: 5,
    fill: "#EC407A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: -5,
    r: 5,
    fill: "#EC407A"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 60,
    fontFamily: "Arial, sans-serif",
    fontSize: 40,
    fontWeight: "bold",
    fill: "#E53935",
    textAnchor: "middle"
  }, "BIRTHDAY SPECIAL")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 100,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#E53935",
    textAnchor: "middle"
  }, "\u20B92000 OFF")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 130,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#D32F2F",
    textAnchor: "middle"
  }, "Celebrate your business anniversary with special savings!")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdaySpecial);
export default __webpack_public_path__ + "static/media/birthday_special.6aa09d81a8a8fa361faf4d7182dba320.svg";
export { ForwardRef as ReactComponent };